export default {
  queryParams: {
    sortBy: "created_at",
    page: 1,
    descending: true,
    rowsPerPage: 15,
    startRow: 0,
    rowsNumber: 0,
    segmentUUID: null,
    "filter.created_at.starts_at": null,
    "filter.created_at.ends_at": null,
    "filter.status.equal": null
  },
  dealts: { dealts: [], total_dealts: 0, total_dealts_finished: 0, total_dealts_ongoing: 0, total_dealts_open: 0 },
  visibleColumns: [],
  dealt: {}
};
